module.exports = __webpack_public_path__ + "asset5_header.png?d3212cf833b692d3ffd41a1032dafa4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/asset5_header.png
// module id = 512
// module chunks = 0